import * as Yup from "yup";

// export const kryzenstoreSchema = Yup.object().shape({
//   title: Yup.string().required("Product title is required"),
//   body_html: Yup.string().required("Description is required"),

//   price: Yup.number()
//     .when("variants", {
//       is: (variants) => !variants || variants.length === 0, // only when no variants
//       then: (schema) =>
//         schema.required("Price is required for single product").min(0, "Price must be ≥ 0"),
//       otherwise: (schema) => schema.notRequired(),
//     }),

//   // sku: Yup.string().when("variants", {
//   //   is: (variants) => !variants || variants.length === 0,
//   //   then: (schema) => schema.required("SKU is required for single product"),
//   //   otherwise: (schema) => schema.notRequired(),
//   // }),

//   inventory_quantity: Yup.number().when("variants", {
//     is: (variants) => !variants || variants.length === 0,
//     then: (schema) =>
//       schema
//         .required("Inventory is required for single product")
//         .min(0, "Inventory must be ≥ 0"),
//     otherwise: (schema) => schema.notRequired(),
//   }),

//   weight: Yup.number().when("variants", {
//     is: (variants) => !variants || variants.length === 0,
//     then: (schema) =>
//       schema.required("Weight is required for single product").min(0, "Weight must be ≥ 0"),
//     otherwise: (schema) => schema.notRequired(),
//   }),

//   inventory_policy: Yup.string().oneOf(["deny", "continue"]),

//   variants: Yup.array().of(
//     Yup.object().shape({
//       price: Yup.number()
//         .required("Price is required")
//         .min(0, "Price must be ≥ 0"),
//       // sku: Yup.string().required("SKU is required"),
//       // inventory_quantity: Yup.number()
//       //   .required("Inventory is required")
//       //   .min(0, "Inventory must be ≥ 0"),
//       weight: Yup.number()
//         .required("Weight is required")
//         .min(0, "Weight must be ≥ 0"),
//       inventory_policy: Yup.string().oneOf(["deny", "continue"]),
//     })
//   ),

//   images: Yup.array().of(
//     Yup.object().shape({
//       src: Yup.string().required(),
//       alt: Yup.string(),
//     })
//   ),
// });

export const kryzenstoreSchema = Yup.object().shape({
  title: Yup.string().required("Required"),
  body_html: Yup.string().required("Required"),
  price: Yup.number().required("Required"), // keeping as string since you said no required
  inventory_quantity: Yup.number().required("Required"),
  weight: Yup.number(),
  weight_unit: Yup.string(),
  inventory_policy: Yup.string().oneOf(["deny", "continue"]),
  variants: Yup.array().of(
    Yup.object().shape({
      price: Yup.string(),
      weight: Yup.string(),
      inventory_policy: Yup.string(),
    })
  ),
  images: Yup.array()
    .of(
      Yup.object().shape({
        src: Yup.string().required("Image source is required"),
        alt: Yup.string(),
      })
    )
    .min(1, "At least one image is required"),
  metafields: Yup.object().shape({
    short_name: Yup.string(),
    short_description: Yup.string(),
  }),
  track_inventory: Yup.boolean(),
  hsn: Yup.string(),
  unit: Yup.string().required("Required"),
  size: Yup.string().required("Required"),
  imageInv: Yup.string(),
  image: Yup.string(),
  specificationsNew: Yup.array(),
  locations: Yup.array()
    .of(Yup.string()) // or Yup.number() depending on your IDs
    .min(1, "At least one location is required")
    .required("Location is required"),
  fabricationChargesMarkup: Yup.string(),
  handlingCharges: Yup.string(),
  optionalWarrantyCovergePerUnit: Yup.string(),
  gst: Yup.string(),
  fabricationProcess: Yup.array().of(Yup.string()),
});
